module.exports = __webpack_public_path__ + "static/img/rank_logo_starlight.9aa90dc5.png";